// Whole numbers in copy: "7", "1,204". parseFormattedNumber accepts the commas it produces,
// so an income field showing "65,000" still calculates as 65000.
// + 1e-9 before truncating so float noise (2.9999999999999996 from a 0.79 FX rate) doesn't drop a unit.

export function parseFormattedNumber(value) {
  if (value == null || value === "") return NaN
  return parseFloat(String(value).replace(/,/g, ""))
}

// A typed money amount: "1000", "1,000" and "25.50" read as numbers. Anything else -- "10,00"
// (10 or 1000?), "1.2.3", "10abc" -- is NaN, so it fails validation instead of parseFloat quietly
// reading "10,000" as 10.
const AMOUNT_FORMAT = /^(\d{1,3}(,\d{3})+|\d+)(\.\d{1,2})?$/

export function parseAmount(value) {
  const text = String(value ?? "").trim()
  if (!AMOUNT_FORMAT.test(text)) return NaN
  return parseFloat(text.replace(/,/g, ""))
}

export function wholeUnits(value) {
  const n = typeof value === "number" ? value : parseFormattedNumber(value)
  if (!Number.isFinite(n)) return NaN
  return Math.trunc(n + 1e-9)
}

export function formatWholeNumber(value) {
  const n = wholeUnits(value)
  if (!Number.isFinite(n)) return ""
  return n.toLocaleString("en-US")
}
